'use client';

import { extractGamesAppVersion } from '@/features/games-app-bridge/internal/helper/extract-games-app-version';
import { extractGamesAppChannel } from '@/features/games-app-bridge/internal/helper/extract-games-app-channel';

export function useWtGamesAppDetails() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return undefined;
  }
  const ua = navigator.userAgent || '';
  return {
    isGamesApp: /\bWTGamesApp\b/i.test(ua),
    gamesAppVersion: extractGamesAppVersion(ua),
    gamesAppChannel: extractGamesAppChannel(ua),
    userAgent: ua,
  };
}
